import i18n from "@/i18n";
import { AccountDetailData } from "../../data/accountDetailData";
import urlFilter from "../../filters/url.filter";
import { ActionModel } from "../../models/ActionModel";
import { ContractsStore } from "../../store/modules/contracts";
import { Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Vue from "vue";

/** Базовая модель представления реквизитов */
export class BaseRequisitesVue extends Vue {
  /**Идентификатор счета */
  @Prop() id!: number;

  @Watch("id", { immediate: true })
  async idChanged(): Promise<void> {
    await this.init();
  }

  /** Флаг формы */
  emailFormIsOpen: boolean = false;

  /**Признак загрузки */
  loading: boolean = false;

  messageTarget: boolean = false;

  /**Стор счетов */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  bankDetails: AccountDetailData | null = null;

  /** реквизиты счета */
  get details(): Array<any> {
    let bankDetails: Array<any> = [];
    if (this.bankDetails) {
      bankDetails = [
        {
          //Владелец Счета
          name: i18n.t("main.contracts.bankDetails.RecepientName"),
          isWrapped: true,
          textVal: this.bankDetails.RecepientName
        },
        {
          //Расчётный/Лицевой счёт
          name: i18n.t("main.contracts.bankDetails.Rs"),
          textVal: this.bankDetails.Rs
        },
        {
          //Банк получателя"
          name: i18n.t("main.contracts.bankDetails.BankName"),
          textVal: this.bankDetails.BankName
        },
        {
          //БИК
          name: i18n.t("main.contracts.bankDetails.Bik"),
          textVal: this.bankDetails.Bik
        },
        {
          //Корр. счёт
          name: i18n.t("main.contracts.bankDetails.Ks"),
          isWrapped: true,
          textVal: this.bankDetails.Ks
        },
        {
          //ИНН
          name: i18n.t("main.contracts.bankDetails.Inn"),
          textVal: this.bankDetails.Inn
        },
        {
          //КПП
          name: i18n.t("main.contracts.bankDetails.Kpp"),
          textVal: this.bankDetails.Kpp
        },
        {
          name: i18n.t("main.contracts.bankDetails.Info"),
          isWrapped: true,
          textVal: this.bankDetails.Info
        }
      ];
    }
    return bankDetails;
  }

  get testEmail(): () => void {
    return () => {
      const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      this.isEmailValid = reg.test(this.emailValue);
    };
  }

  async sendEmail() {
    if (!this.messageTarget) this.testEmail();
    if (this.isEmailValid || this.messageTarget) {
      this.emailLoading = true;
      const model: ActionModel = new ActionModel();
      model.Data["contractId"] = this.id;
      if (!this.messageTarget) model.Data["email"] = this.emailValue;
      else model.Data["phone"] = this.phoneValue.replace(/\s|\(|\)|\-/g, "");
      await this.contractsStore.sendAccountDetail(model);
      this.emailLoading = false;
    }
    // else
    //   Vue.$toast.open({
    //     message: i18n.t("main.contracts.errors.incorrectEmail"),
    //     type: "error",
    //   });
  }
  /** Значение емайла в окне реквизитов */
  emailValue: string = "";
  emailLoading: boolean = false;
  isEmailValid: boolean = true;
  phoneValue: string = "";

  /**Распечатать реквизиты */
  print() {
    window.open(urlFilter(`/Contract/Requisites/${this.id}`), "_blank");
  }

  destroyOperation() {
    this.$emit("hideSelf");
  }

  async init() {
    this.loading = true;
    this.bankDetails = this.contractsStore.contracts.getContract(
      this.id
    )?.BankDetails;
    if (!this.bankDetails) {
      this.bankDetails = await this.contractsStore.updateBankDetails(this.id);
    }
    this.loading = false;
  }
}
